// player/PlayerPill.ts — the small glass pill used on the player's corners (Sound on, the
// duration) and on the Flash page.
import styled from 'styled-components';

const INK = '#fff';

export const PlayerPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(14, 10, 26, 0.62);
  backdrop-filter: blur(6px);
  color: ${INK};
  font: 600 13px ${({ theme }) => theme.font.body};
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  &:hover {
    background: rgba(40, 30, 64, 0.72);
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
  }
`;
